module.exports = __webpack_public_path__ + "img/c-bg-dark.f88f91c0.png";